import { isBoolean } from 'lodash-es'

import {
  toHex,
  toText,
  toLower,
  toBoolean,
  toOpacity,
  toPosNumber,
  toPosInteger,
  toPosOddInteger,
  isHex,
  isText,
  isLower,
  isOpacity,
  isPosNumber,
  isPosInteger,
  isCampaignKey,
  isPosOddInteger
} from '../utils/bits'

import { toUrl, isUrl, toSrc, isSrc, htmlWithSafeLinks } from '../utils/security'

import MemoizeDeep from '../utils/memoize-deep'
import MemoizeSimple from '../utils/memoize-simple'

import { isFeatures, toFeatures } from './gallery-properties.flow.step.cast.pair.features'
import { isCustomPlan, toCustomPlan } from './gallery-properties.flow.step.cast.pair.custom-plan'
import { isMessageBundle, toMessageBundle } from './gallery-properties.flow.step.cast.pair.message-bundle'

const memToMessageBundle = MemoizeDeep(toMessageBundle)
const memIsMessageBundle = MemoizeDeep(isMessageBundle)
const memHtmlWithSafeLinks = MemoizeSimple(htmlWithSafeLinks)

import { signValueCast } from './gallery-properties.flow'

export const castUrl = Cast(toUrl, isUrl)
export const castSrc = Cast(toSrc, isSrc)
export const castCss = Cast(toText, isText)
export const castHex = Cast(toHex, isHex)
export const castHtml = Cast(memHtmlWithSafeLinks, isText)
export const castText = Cast(toText, isText)
export const castBool = Cast(toBoolean, isBoolean)
export const castLower = Cast(toLower, isLower)
export const castPosInt = Cast(toPosInteger, isPosInteger)
export const castOpacity = Cast(toOpacity, isOpacity)
export const castPosFloat = Cast(toPosNumber, isPosNumber)
export const castFeatures = Cast(toFeatures, isFeatures)
export const castPosOddInt = Cast(toPosOddInteger, isPosOddInteger)
export const castCustomPlan = Cast(toCustomPlan, isCustomPlan)
export const castCampaignKey = Cast(toText, isCampaignKey)
export const castMessageBundle = Cast(memToMessageBundle, memIsMessageBundle)

function Cast(typeCast, typeCheck) {
  return signValueCast(cast)

  function cast(result) {
    const castResult = typeCast(result)
    const checkResult = typeCheck(castResult)
    return checkResult ? castResult : null
  }
}
